import { createQueryDefinition, createQueryHook } from 'common/services/queryBuilder';

import { list as listFn } from './api';

const GetAdminCompanyQuery = createQueryDefinition(
  () => ['company-events'] as const,
  () => listFn(),
);

export const useCompanyEventsQuery = createQueryHook(GetAdminCompanyQuery, {
  select: ({ data }) => data,
});
